export default __webpack_public_path__ + "static/char-v-35-f88aaebc78e2eadae8c4664fc0937523.webp";